import React from 'react';
import Icon from '../Icon';

const IconAgile = (props) => {
  const {
    size,
    inverse,
    onClick,
    role,
  } = props;

  return (
    <Icon
      size={size}
      inverse={inverse}
      onClick={onClick}
      classNameIconType="c-icon-agile"
      role={role}
    >
      <svg
        viewBox="0 0 52 52"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M36.4258 31.5493C36.5718 31.5584 36.7291 31.5766 36.8864 31.5766C39.1143 31.5789 41.3444 31.5652 43.5722 31.588C44.0602 31.5926 44.2062 31.4261 44.1811 30.9587C44.1491 30.3498 44.1742 29.7387 44.1742 28.9862C46.7031 30.8469 49.1475 32.6438 51.6558 34.4908C49.1658 36.3242 46.7213 38.1233 44.1742 40C44.1742 39.2908 44.1742 38.7048 44.1742 38.1188C44.1742 37.3617 44.1742 37.3594 43.4377 37.3594C29.1928 37.3594 14.9456 37.3594 0.700619 37.3594C0.0119731 37.3594 0.011973 37.3594 0.011973 36.6662C0.011973 35.1635 0.0324964 33.6608 0.000572439 32.1604C-0.010829 31.6724 0.14651 31.563 0.613968 31.5652C8.27344 31.5789 15.9329 31.5903 23.5924 31.5698C27.519 31.5584 30.6179 29.9325 32.6679 26.5486C36.3665 20.4374 32.5106 12.4336 25.4235 11.403C19.9508 10.6071 14.8635 14.2807 13.9354 19.8468C13.8373 20.426 13.8305 21.0212 13.7735 21.719C14.6696 21.5981 15.4814 21.4864 16.4004 21.3632C14.9615 24.1452 13.5728 26.8314 12.1636 29.554C10.0042 27.3285 7.87667 25.1371 5.79705 22.9936C6.31924 22.907 7.01244 22.8067 7.69881 22.663C7.82879 22.6356 8.02033 22.4259 8.01577 22.305C7.977 20.8479 8.07734 19.4068 8.36237 17.977C8.37149 17.9337 8.35097 17.8835 8.33729 17.7992C6.94632 17.562 5.65568 17.0603 4.48589 16.2531C1.62641 14.2738 0.130548 10.5912 0.832875 7.2346C1.59677 3.57703 4.35591 0.842964 7.92228 0.168C10.2345 -0.267534 12.378 0.147479 14.3686 1.36971C14.7198 1.58634 14.9341 1.61826 15.1645 1.24201C15.299 1.02083 15.5019 0.842964 15.7345 0.573891C16.0241 1.7414 16.2955 2.83365 16.5646 3.92591C16.6558 4.29303 16.7265 4.667 16.8336 5.02957C16.9499 5.42177 16.8313 5.59736 16.4163 5.56999C15.2169 5.4879 14.0152 5.41493 12.8158 5.33512C12.5193 5.3146 12.2252 5.28268 11.8444 5.24619C12.1408 4.87223 12.4099 4.53702 12.704 4.1699C12.0564 3.67736 11.3427 3.43109 10.5993 3.31023C7.0056 2.72192 3.83829 5.48334 3.91126 9.12039C3.96599 11.9115 6.31924 14.4061 9.0989 14.6432C9.45919 14.6729 9.58461 14.4905 9.7237 14.2214C11.6939 10.4407 14.6605 7.76819 18.6966 6.37721C28.0344 3.15745 37.7826 8.92657 39.5817 18.3692C40.4688 23.0187 39.4586 27.2646 36.6379 31.0704C36.5604 31.1753 36.4897 31.287 36.4213 31.3988C36.4076 31.4193 36.4258 31.4603 36.4372 31.547L36.4258 31.5493Z"
        />
      </svg>
    </Icon>
  );
};

export default IconAgile;
